import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AmazingTimePickerModule } from './atp-library/atp-time-picker.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularDualListBoxModule } from 'angular-dual-listbox';

import { CollapsibleDividerComponent } from './components/collapsible-divider/collapsible-divider.component';
import { ControlGroupComponent } from './components/control-group/control-group.component';
import { ControlRefDirective } from './directives/control-ref.directive';
import { ZipCodeDirective } from './directives/masking/zip-code.directive';
import { ZipCodeFullDirective } from './directives/masking/zip-code-full.directive';
import { PhoneDirective } from './directives/masking/phone.directive';
import { PhoneExtDirective } from './directives/masking/phone-ext.directive';
import { SsnDirective } from './directives/masking/ssn.directive';
import { DateDirective } from './directives/masking/date-directive';
import { StepsComponent } from './components/steps/steps.component';
import { SvgModule } from './svg/svg.module';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { ClockPickerComponent } from './components/clock-picker/clock-picker.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { DualListBoxComponent } from './components/dual-list-box/dual-list-box.component';
import { TimeDirective } from './directives/masking/time.directive';
import { SelectComponent } from './components/select/select.component';
import { RadioButtonListComponent } from './components/radio-button-list/radio-button-list.component';
import { TouchRadioButtonListComponent } from './components/touch-radio-button-list/touch-radio-button-list.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FixedButtonsComponent } from './components/fixed-buttons/fixed-buttons.component';
import { NumericDirective } from './directives/masking/numeric.directive';
import { CurrencyService } from './directives/masking/currency.service';
import { CurrencyDirective } from './directives/masking/currency.directive';
import { PercentageDirective } from './directives/masking/percentage.directive';
import { PercentageService } from './directives/masking/percentage.service';
import { FeinDirective } from './directives/masking/fein.directive';
import { NdcDirective } from './directives/masking/ndc.directive';
import { AbbreviationDirective } from './directives/masking/abbreviation.directive';
import { SubmitUrlDirective } from './directives/submit-url.directive';
import { NumberDecimalDirective } from './directives/masking/number-decimal.directive';
import { ActionButtonComponent } from './components/action-button/action-button.component';
import { DownloadButtonComponent } from './components/download-button/download-button.component';
import { UploadButtonComponent } from './components/upload-button/upload-button.component';

@NgModule({
	declarations: [
		// These two are used for control validation
		ControlGroupComponent,
		ControlRefDirective,
		// This is our collapsibe divider
		CollapsibleDividerComponent,
		// Pre-defined mask directives
		ZipCodeDirective,
		ZipCodeFullDirective,
		PhoneDirective,
		PhoneExtDirective,
		SsnDirective,
		DateDirective,
		PercentageDirective,
		NdcDirective,
		FeinDirective,
		// Replacement for the steps plugin
		StepsComponent,
		DatePickerComponent,
		ClockPickerComponent,
		DateRangeComponent,
		DualListBoxComponent,
		TimeDirective,
		SelectComponent,
		RadioButtonListComponent,
		TouchRadioButtonListComponent,
		FileUploadComponent,
		FixedButtonsComponent,
		NumericDirective,
		CurrencyDirective,
		AbbreviationDirective,
		SubmitUrlDirective,
		NumberDecimalDirective,
		ActionButtonComponent,
		DownloadButtonComponent,
		UploadButtonComponent
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		SvgModule,
		NgbDatepickerModule,
		AmazingTimePickerModule,
		AngularEditorModule,
		AngularDualListBoxModule,
		NgbPopoverModule,
		NgSelectModule,
		NgbTooltipModule,
		RouterModule,
	],
	exports: [
		// These two are used for control validation
		ControlGroupComponent,
		ControlRefDirective,
		// This is our collapsibe divider
		CollapsibleDividerComponent,
		// Pre-defined mask directives
		ZipCodeDirective,
		ZipCodeFullDirective,
		PhoneDirective,
		PhoneExtDirective,
		SsnDirective,
		DateDirective,
		TimeDirective,
		NumericDirective,
		CurrencyDirective,
		AbbreviationDirective,
		PercentageDirective,
		NdcDirective,
		FeinDirective,
		NumberDecimalDirective,
		// Replacement for the steps plugin
		StepsComponent,
		SvgModule,
		DatePickerComponent,
		ClockPickerComponent,
		DateRangeComponent,
		DualListBoxComponent,
		SelectComponent,
		RadioButtonListComponent,
		TouchRadioButtonListComponent,
		FileUploadComponent,
		FixedButtonsComponent,
		SubmitUrlDirective,
		ActionButtonComponent,
		DownloadButtonComponent,
		UploadButtonComponent
	],
	providers: [CurrencyService, PercentageService],
})
export class FormElementsModule {}
